/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Prompt } from 'react-router-dom';
import IconButton from 'components/IconButton';
// import InputText from 'components/FormInputText';
import EditableLabel from 'components/FormEditableLabel';
import actions from 'redux/actions';
import { getIsFetching } from 'redux/reducers/worklists';
import validation from './validation';
import styles from './styles.module.scss';

import type { Translate, ReduxState } from 'types';

export type FormValues = {
  name: string,
  description: string,
};

type Props = {
  isLoading: boolean,
  valid: boolean,
  pristine: boolean,
  dirty: boolean,
  t: Translate,
  router: mixed,
};

const mapStateToProps = (state: ReduxState) => ({
  isLoading: getIsFetching(state),
});

class WorklistHeaderForm extends React.Component<Props, void> {
  render() {
    const { isLoading, dirty, t } = this.props;
    return (
      <div className={styles.form}>
        <Prompt when={dirty} message={location => t('CONFIRM_EXIT_DIRTY_FORM')} />
        <div className={styles.title}>
          <Field
            component={EditableLabel}
            name={'name'}
            disabled={isLoading}
            render={props => (
              <div className={styles.titleInput} {...props}>
                {props.children}
                <IconButton icon={'edit'} tooltip={t('EDIT')} className={styles.titleInputIcon} />
              </div>
            )}
          />
        </div>
        <div className={styles.description}>
          <Field
            component={EditableLabel}
            name={'description'}
            multiline
            rows={5}
            disabled={isLoading}
            render={props => (
              <div className={styles.descriptionInput} {...props}>
                {props.children}
                <IconButton
                  icon={'edit'}
                  tooltip={t('EDIT')}
                  className={styles.descriptionInputIcon}
                />
              </div>
            )}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(
  connect(
    mapStateToProps,
    actions
  )(
    reduxForm({
      form: 'worklistHeader',
      validate: validation,
      enableReinitialize: true,
      //$FlowFixMe
      // destroyOnUnmount: !(keys.IS_ENV_DEVELOPMENT && module.hot),
      destroyOnUnmount: true,
    })(WorklistHeaderForm)
  )
);
